export default __webpack_public_path__ + "static/media/NesoLogoLightThorium.bc6446dd.svg";